
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured-this-week",
      function () {
        return require("private-next-pages/featured-this-week.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured-this-week"])
      });
    }
  